import { element, globalEvent } from '@shared/easyfy.core';
import { invoke } from '@shared/easyfy.decorators';

/**
 * @deprecated Use `Meds.Managers.DialogManager` instead.
 * This module will be removed after the migration to <dialog>.
 */
namespace Meds.Modules {
  /**
   * @deprecated Use `Meds.Managers.DialogManager.open(dialog)` or data attributes
   * (`[data-dialog-open]`, `[data-dialog-close]`).
   */
  @invoke
  export class DialogModule {
    /**
     * @deprecated Prefer DialogManager + returnValue flows, or
     * `DialogManager.open(dialog)` for general usage.
     */
    static ShowDialog = async (dialog: HTMLDialogElement): Promise<any> =>
      new Promise((resolve) => {
        // Listen for the close event to get the returnValue
        dialog.addEventListener('close', (e: CloseEvent) => {
          const eventTargetElement = e.target as HTMLDialogElement;
          resolve(eventTargetElement.returnValue);
        });

        // Show the dialog
        dialog.showModal();
      });
  }
}

export default Meds.Modules.DialogModule;
